import React from 'react'
import spin from '../../assets/spinner.gif'

export default function Spinner() {
    return (
        <div>
            <img 
                src={spin}
                alt="Loading"
                style={{width: 200, margin: '40px auto', display: 'block'}}
            />
        </div>
    )
}
